import * as types from '../../action-types';
import { getOneCycle as initialState } from '../initialStates';

const getOneCycle = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.GET_ONE_CYCLE_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.GET_ONE_CYCLE_SUCCESS:
            return {
                ...state,
                isSuccessful: true,
                data: payload,
            }
        case types.GET_ONE_CYCLE_FAIL:
            return {
                ...state,
                error: payload
            }
        case types.GET_ONE_CYCLE_CLEANUP:
            return {
                ...state,
                error: null,
                isSuccessful: false
            }
        default:
            return state;
    };
};

export default getOneCycle;

